module.exports = __webpack_public_path__ + "img/visa_logo.ffe0e08f.png";